import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/applicationintro')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
